module.exports = __webpack_public_path__ + "static/assets/ff169762ee7ccd6dbaf5387579730ab4.png";